<template>
  <div class="row">
    <div class="course-content-editor-container  small-12 columns">
      <div
        class="close-button absolute cursor-pointer"
        title="Close (Esc)"
        @click="$emit('CLOSE_MODAL')"
      >
        ❌
      </div>
      <div class="small-12 columns">
        <div><h2>Module Editing</h2></div>
        <div class="small-3 columns">Name</div>
        <div class="small-9 columns">
          <input
            v-model="module.name"
            type="text"
            class="input-box-course-creators"
          />
        </div>
        <div class="small-12 columns">
          <div class="small-3 columns">is Required</div>
          <div class="small-9 columns">
            <input v-model="module.is_required" type="checkbox" />
          </div>
        </div>
        <div class="small-12 columns">
          <div class="row">
            <div class="small-3 columns">is bonus</div>
            <div class="small-9 columns">
              <input v-model="module.is_bonus" type="checkbox" />
            </div>
          </div>
        </div>
        <div class="small-12 columns">
          <div class="small-3 columns">is Payment locked</div>
          <div class="small-9 columns">
            <input v-model="module.is_payment_locked" type="checkbox" />
          </div>
        </div>
        <div class="small-12 columns">
          <div class="small-3 columns">Is Dependent IDs</div>
          <div class="small-9 columns">
            <multiselect
              v-model="selected"
              :taggable="true"
              :options="modules"
              label="name"
              :multiple="true"
              @remove="removeTag"
            />
          </div>
        </div>

        <div class="small-12 columns">
          <div class="small-3 columns">Phase</div>
          <div class="small-9 columns">
            <VueSelect
              class="mb-2 bg-white"
              placeholder="Select a Phase"
              :options="phaseOptions"
              label="name"
              :value="getPhaseName"
              :reduce="option => option.name"
              @input="setPhase"
            />
          </div>
        </div>

        <div class="small-12 columns">
          <button
            class="button-font button-green py-2 px-4 rounded-sm"
            style="margin-right:20px;"
            @click="editModule"
          >
            Done
          </button>
          <button
            class="button-red button-font py-2 px-4 rounded-sm"
            @click="deleteModule"
          >
            Delete Module
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect"
import { mapGetters, mapActions } from "vuex"
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"

export default {
  components: { Multiselect, VueSelect },
  props: ["module", "modules", "phaseOptions"],
  data() {
    return {
      name: "",
      is_bonus: false,
      is_required: false,
      is_payment_locked: false,
      selected: [],
    }
  },
  methods: {
    ...mapActions("module", [
      "UPDATE_MODULE",
      "LOAD_CURRENT_COURSES_EDITING_STATE",
    ]),
    setPhase(option) {
      this.module.phase_id = option ? option.id : undefined
    },
    removeTag(tag) {
      let index
      for (let i = 0; i < this.selected.length; i++) {
        if (this.selected[i].id === tag.id) {
          index = i
        }
      }
      this.selected = this.selected.splice(index, 1)
    },
    updateProps() {},
    editModule() {
      this.module.is_dependent_ids = this.selected.map(item => item.id)

      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}admin/modules/${this.module.id}`,
        data: {
          name: this.module.name,
          is_dependent_ids: this.module.is_dependent_ids,
          is_bonus: this.module.is_bonus,
          is_required: this.module.is_required,
          is_payment_locked: this.module.is_payment_locked,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.module.slug = res.data.slug

        this.$emit("MODULE_UPDATED", this.module)
      })
    },
    deleteModule() {
      this.$emit("MODULE_DELETE", this.module.id)
    },
    getSelectedModules() {
      const selected = []
      for (let i = 0; i < this.modules.length; i++) {
        for (let j = 0; j < this.module.is_dependent_ids.length; j++) {
          if (this.modules[i].id === this.module.is_dependent_ids[j]) {
            selected.push(this.modules[i])
          }
        }
      }
      this.selected = selected
    },
  },

  computed: {
    ...mapGetters("module", ["getCurrentEditingModule"]),
    data() {
      return this.getCurrentEditingModule
    },
    getPhaseName() {
      const phase = this.phaseOptions.find(p => p.id === this.module.phase_id)
      if (phase) {
        return phase.name
      }
      return undefined
    },
  },

  mounted() {
    this.getSelectedModules()
  },
}
</script>

<style>
.button-font {
  font-size: 0.7em !important;
}
</style>
